
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/warranty-direct",
      function () {
        return require("private-next-pages/warranty-direct.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/warranty-direct"])
      });
    }
  